import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories, getFeaturedArticles, getLatestArticles, getHotArticles } from '@/mocks/articles';
import { getArticleImage } from '@/mocks/images';

export default function Home() {
  const featuredArticles = getFeaturedArticles();
  const latestArticles = getLatestArticles(9);
  const hotArticles = getHotArticles();

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '爆料网',
    url: 'https://baoliaowang.com',
    description: '网红爆料·娱乐爆料网·八卦爆料网 | 网红吃瓜吃料网每日爆料，最新网红吃瓜黑料八卦汇总每日更新',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://baoliaowang.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爆料网',
    url: 'https://baoliaowang.com',
    description: '网红圈最新八卦爆料，娱乐爆料网、八卦爆料网实时更新，网红吃瓜吃料网每日爆料合集',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative pt-16">
          <div className="relative h-[520px] md:h-[620px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20abstract%20composition%20with%20warm%20crimson%20and%20dark%20accents%2C%20representing%20breaking%20news%20and%20media%20buzz%2C%20dynamic%20geometric%20patterns%2C%20modern%20editorial%20style%2C%20bold%20visual%20impact%2C%20clean%20and%20sophisticated%20atmosphere%2C%20no%20text&width=1600&height=700&seq=home-hero&orientation=landscape"
              alt="爆料网 - 网红爆料八卦资讯"
              title="爆料网 - 网红爆料·娱乐爆料·八卦爆料"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
              <div className="w-full max-w-4xl">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500/90 rounded-full mb-6">
                  <i className="ri-fire-fill text-background-50 animate-pulse"></i>
                  <span className="text-sm text-background-50 font-medium">每日更新 新鲜瓜料一网打尽</span>
                </div>
                <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
                  网红爆料 · 娱乐八卦
                </h1>
                <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8">
                  网红圈最新八卦爆料实时更新，网红吃瓜、黑料、八卦汇总，每日新鲜瓜料一网打尽。关注爆料网，不错过任何一个瓜！
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/wanghong-xiangliao"
                    className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
                  >
                    查看最新爆料
                  </Link>
                  <Link
                    to="/category/wanghong-chigua"
                    className="px-8 py-3 bg-background-50/20 text-white border border-white/30 font-medium rounded-full hover:bg-background-50/30 transition-colors whitespace-nowrap"
                  >
                    开始吃瓜
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Stats bar */}
          <div className="w-full bg-background-50 border-b border-background-200/70">
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-center gap-8 md:gap-16 text-sm">
              <div className="text-center">
                <div className="font-heading text-xl font-bold text-primary-600">12,850+</div>
                <div className="text-xs text-foreground-500 mt-0.5">累计爆料</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-xl font-bold text-primary-600">860万+</div>
                <div className="text-xs text-foreground-500 mt-0.5">月度阅读</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-xl font-bold text-primary-600">35万+</div>
                <div className="text-xs text-foreground-500 mt-0.5">忠实读者</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-xl font-bold text-primary-600">6</div>
                <div className="text-xs text-foreground-500 mt-0.5">内容分类</div>
              </div>
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-12 md:py-16 px-6 md:px-10 bg-background-100/60">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  头条爆料
                </h2>
                <p className="text-sm text-foreground-600 mt-1">最新最热的网红八卦资讯</p>
              </div>
              <Link
                to="/category/wanghong-xiangliao"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {featuredArticles.slice(0, 2).map((article) => (
                <ArticleCard
                  key={article.slug}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  category={article.category}
                  categoryName={categories.find((c) => c.slug === article.category)?.name || ''}
                  imageUrl={getArticleImage(article.slug, 'featured')}
                  author={article.author}
                  date={article.date}
                  views={article.views}
                  tags={article.tags}
                  variant="featured"
                />
              ))}
            </div>
          </div>
        </section>

        {/* Category Navigation + Latest Articles */}
        <section className="py-12 md:py-16 px-6 md:px-10">
          <div className="max-w-7xl mx-auto">
            {/* Category pills */}
            <div className="flex items-center gap-2 mb-10 overflow-x-auto pb-2 flex-wrap">
              <Link
                to="/"
                className="px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap"
              >
                全部
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-5 py-2.5 bg-background-100 text-foreground-700 text-sm font-medium rounded-full hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {/* Latest grid + Hot sidebar */}
            <div className="flex flex-col lg:flex-row gap-8">
              {/* Main content */}
              <div className="flex-1">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
                  最新爆料
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {latestArticles.map((article) => (
                    <ArticleCard
                      key={article.slug}
                      slug={article.slug}
                      title={article.title}
                      excerpt={article.excerpt}
                      category={article.category}
                      categoryName={categories.find((c) => c.slug === article.category)?.name || ''}
                      imageUrl={getArticleImage(article.slug, 'card')}
                      author={article.author}
                      date={article.date}
                      views={article.views}
                      tags={article.tags}
                    />
                  ))}
                </div>
              </div>

              {/* Sidebar */}
              <aside className="lg:w-[320px] flex-shrink-0">
                <div className="sticky top-24">
                  <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 mb-6">
                    <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4 flex items-center gap-2">
                      <i className="ri-fire-fill text-accent-500"></i>
                      热搜排行
                    </h3>
                    <div className="space-y-1">
                      {hotArticles.map((article, index) => (
                        <ArticleCard
                          key={article.slug}
                          slug={article.slug}
                          title={article.title}
                          excerpt={article.excerpt}
                          category={article.category}
                          categoryName={categories.find((c) => c.slug === article.category)?.name || ''}
                          imageUrl={getArticleImage(article.slug, 'compact')}
                          author={article.author}
                          date={article.date}
                          views={article.views}
                          tags={article.tags}
                          variant="compact"
                        />
                      ))}
                    </div>
                  </div>

                  {/* Newsletter */}
                  <div className="bg-primary-500 rounded-lg p-5 text-background-50">
                    <h4 className="font-heading text-base font-bold mb-2">订阅爆料推送</h4>
                    <p className="text-sm text-primary-100 mb-4">不错过任何一个瓜，最新爆料第一时间推送！</p>
                    <form
                      data-readdy-form="true"
                      action="https://readdy.ai/api/form/d9oppj8senbniolesjhg"
                      method="POST"
                      encType="application/x-www-form-urlencoded"
                    >
                      <input
                        type="email"
                        name="email"
                        placeholder="输入邮箱地址"
                        required
                        className="w-full px-4 py-2.5 rounded-lg text-sm text-foreground-950 bg-background-50 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-background-50/50 mb-3"
                      />
                      {/* Anti-spam honeypot */}
                      <input
                        type="text"
                        name="website_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                        className="spambot-trap"
                      />
                      <button
                        type="submit"
                        className="w-full px-4 py-2.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-900 transition-colors whitespace-nowrap"
                      >
                        立即订阅
                      </button>
                    </form>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        {/* Category cards section */}
        <section className="py-12 md:py-16 px-6 md:px-10 bg-background-100/60">
          <div className="max-w-7xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">
              热门分类
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">选择你感兴趣的内容分类，发现更多精彩爆料</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center text-center p-5 rounded-lg bg-background-50 hover:bg-primary-50 transition-colors"
                >
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-500 transition-colors">
                    <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
                  </div>
                  <h4 className="font-heading text-sm font-bold text-foreground-950 mb-1">{cat.name}</h4>
                  <p className="text-xs text-foreground-500 line-clamp-2">{cat.description}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-12 md:py-16 px-6 md:px-10">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">
              常见问题
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">关于爆料网，你想知道的都在这里</p>
            <div className="space-y-3">
              {[
                {
                  q: '爆料网的信息来源可靠吗？',
                  a: '爆料网的内容均来自公开网络信息和网友投稿，我们会对信息进行多方核实和交叉验证，但娱乐八卦类信息难免存在主观成分，请读者理性看待。',
                },
                {
                  q: '爆料内容多久更新一次？',
                  a: '爆料网保持每日更新，我们的编辑团队7×24小时关注网红圈和娱乐圈动态，确保第一时间为读者带来最新鲜的瓜料。',
                },
                {
                  q: '如何向爆料网投稿？',
                  a: '您可以通过网站底部的联系方式或关于我们页面的联系表单向我们提供爆料线索，我们会对每一条投稿进行认真审核。',
                },
                {
                  q: '爆料网会泄露投稿人信息吗？',
                  a: '我们严格保护投稿人的隐私信息，所有投稿均采用匿名处理，未经投稿人明确同意，绝不会向第三方透露任何个人信息。',
                },
              ].map((faq, index) => (
                <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors">
                    <span className="font-heading text-base font-bold text-foreground-950 pr-4">{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{faq.a}</div>
                </details>
              ))}
            </div>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                  '@context': 'https://schema.org',
                  '@type': 'FAQPage',
                  mainEntity: [
                    { '@type': 'Question', name: '爆料网的信息来源可靠吗？', acceptedAnswer: { '@type': 'Answer', text: '爆料网的内容均来自公开网络信息和网友投稿，我们会对信息进行多方核实和交叉验证，但娱乐八卦类信息难免存在主观成分，请读者理性看待。' } },
                    { '@type': 'Question', name: '爆料内容多久更新一次？', acceptedAnswer: { '@type': 'Answer', text: '爆料网保持每日更新，我们的编辑团队7×24小时关注网红圈和娱乐圈动态，确保第一时间为读者带来最新鲜的瓜料。' } },
                    { '@type': 'Question', name: '如何向爆料网投稿？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过网站底部的联系方式或关于我们页面的联系表单向我们提供爆料线索，我们会对每一条投稿进行认真审核。' } },
                    { '@type': 'Question', name: '爆料网会泄露投稿人信息吗？', acceptedAnswer: { '@type': 'Answer', text: '我们严格保护投稿人的隐私信息，所有投稿均采用匿名处理，未经投稿人明确同意，绝不会向第三方透露任何个人信息。' } },
                  ],
                }),
              }}
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}